import V2Adapter from './v2';

export default class V3Adapter extends V2Adapter {
  namespace = 'api/v3';
}
